<template>
  <div>
    <v-jsoneditor
      v-model="attributes"
      :options="options"
      :plus="false"
      height="350px"
      @error="onError"
      @input="onInput"
    ></v-jsoneditor>
    <b-alert variant="danger" class="mt-2" :show="hasError">
      <em class="fa fa-times-circle mr-2"></em>{{ $t("commons.invalid_data") }}
    </b-alert>
    <b-alert variant="danger" class="mt-2" :show="hasEmptyAttribute">
      <em class="fa fa-times-circle mr-2"></em
      >{{ $t("commons.attribute_name_empty") }}
    </b-alert>
  </div>
</template>

<script>
import { useManageAttributes } from "../../stores/manage-attributes";
export default {
  computed: {
    attributes: {
      get() {
        return this.useManageAttributes.getForm.attributes;
      },
      set(attributes) {
        this.useManageAttributes.updateAttributes(attributes);
      },
    },
    attributesList() {
      return this.useManageAttributes.getForm.attributesList;
    },
    hasError() {
      return this.useManageAttributes.getForm.jsonEditorError;
    },
    hasEmptyAttribute() {
      return this.attributesList.find((i) => i.hasNameError == true) != null;
    },
  },
  data() {
    return {
      useManageAttributes: useManageAttributes(),
    };
  },
  methods: {
    onError(e) {
      this.useManageAttributes.updateJsonEditorError(true);
    },
    onInput(e) {
      this.useManageAttributes.updateJsonEditorError(false);
    },
  },
};
</script>
